import { AuthService } from './auth.service';

// Criar uma instância única do serviço de autenticação
const authService = new AuthService();

// Exportar a instância para uso em toda a aplicação
export default authService;

// Re-exportar tipos úteis
export type {
  RegisterData,
  UpdateProfileData,
  UserData,
  Profile,
} from './types';